import React from "react";
import { Col, Row } from "react-bootstrap";

import { InvoiceState } from "../../../types/invoice";

type BeneficiaryDetailsProps = {
    invoice: InvoiceState;
};

const PaymentBeneficiaryDetails = ({
    invoice,
}: BeneficiaryDetailsProps): JSX.Element => {
    return (
        <div className="p-0 mb-3">
            <dl>
                <h1 className="mb-3 rem-1-5">Beneficiary Details</h1>
                <Row>
                    <Col>
                        <dt>
                            <p className="text-label-grey mb-2">
                                Beneficiary Bank Account
                            </p>
                        </dt>
                        <dd>
                            <p className="fw-bold mb-0">
                                {invoice.props.bankAccountDetails.bankAccountHolderName}
                            </p>
                            <p className="fw-bold mb-3">
                                {invoice.props.bankAccountDetails.bankAccountNumberStr}
                            </p>
                        </dd>
                    </Col>
                    <Col>
                        <dt>
                            <p className="text-label-grey mb-2">
                                Beneficiary Bank
                            </p>
                        </dt>
                        <dd>
                            <p className="fw-bold mb-3">
                                {invoice.props.bankAccountDetails.swiftAddress} -{" "}
                                {invoice.props.bankAccountDetails.bankName}
                            </p>
                        </dd>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <dt>
                            <p className="text-label-grey mb-2">
                                Requested Amount
                            </p>
                        </dt>
                        <dd>
                            <p className="fw-bold mb-0">{invoice.props.amount}</p>
                        </dd>
                    </Col>
                    <Col>
                        <dt>
                            <p className="text-label-grey mb-2">
                                Beneficiary Address
                            </p>
                        </dt>
                        <dd>
                            <p className="fw-bold mb-0">
                                {invoice.props.bankAccountDetails.registeredAddress}
                            </p>
                        </dd>
                    </Col>
                </Row>
            </dl>
        </div>
    );
};

export default PaymentBeneficiaryDetails;
